class AssistantWebsocketManager {
  constructor(onMessage, onOpen, onError, onClose) {
    this.ws = null;
    this.url = process.env.REACT_APP_ASSISTANT_WEBSOCKET;

    this.onMessage = onMessage;
    this.onOpen = onOpen;
    this.onError = onError;
    this.onClose = onClose;
  }

  connect() {
    this.ws = new WebSocket(this.url);

    this.ws.onopen = () => {
      this.onOpen();
    };

    this.ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        this.onMessage?.(data);
      } catch (e) {
        console.error('Error parsing WebSocket message', e);
      }
    };

    this.ws.onerror = (event) => {
      console.error('WebSocket error:', event);
      this.onError?.(event);
    };

    this.ws.onclose = () => {
      this.onClose?.();
    };
  }

  send(data) {
    if (this.ws?.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(data));
    } else {
      console.warn('WebSocket is not open. Cannot send message.');
    }
  }

  close() {
    if (this.ws) {
      this.ws.onopen = null;
      this.ws.onmessage = null;
      this.ws.onerror = null;
      this.ws.onclose = null;
      this.ws.close();
      this.ws = null;
    }
  }
}

export default {
  AssistantWebsocketManager,
};
